var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgDeletelogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 69,
    height: 69,
    viewBox: "0 0 71 71",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M0.917969 35.4976C0.917969 16.411 16.4113 0.914246 35.5013 0.914246C54.6259 0.914246 70.0846 16.411 70.0846 35.4976C70.0846 54.591 54.6259 70.0809 35.5013 70.0809C16.4113 70.0809 0.917969 54.591 0.917969 35.4976ZM32.458 22.3905C32.458 20.734 33.8413 19.3472 35.5013 19.3472C37.1613 19.3472 38.5101 20.734 38.5101 22.3905V37.6763C38.5101 39.3398 37.1613 40.6851 35.5013 40.6851C33.8413 40.6851 32.458 39.3398 32.458 37.6763V22.3905ZM35.5359 51.686C33.8413 51.686 32.4926 50.3027 32.4926 48.6427C32.4926 46.9827 33.8413 45.634 35.5013 45.634C37.1959 45.634 38.5446 46.9827 38.5446 48.6427C38.5446 50.3027 37.1959 51.686 35.5359 51.686Z",
    fill: "#FE3E3E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeletelogo);
export default __webpack_public_path__ + "static/media/deletelogo.a3d3a4d5333d16b8c953728911a20c40.svg";
export { ForwardRef as ReactComponent };